import { Box, Dialog, DialogContent, DialogProps, IconButton, Slide, Typography } from "@mui/material";
// import  Icon from '../../assets/icons/alert/Featured icon (1).svg'
import { ButtonContained, ButtonOutlined } from "../button/ButtonCustoms";
import CancelPresentationOutlinedIcon from '@mui/icons-material/CancelPresentationOutlined';
import React from "react";
import { TransitionProps } from "@mui/material/transitions";
import ContainerButton from "../button/ContainerButton";
import { useTranslation } from "react-i18next";

type ModalProps = {
    open: boolean
    handleClose: () => void
    onClick: () => void
    title: string
    subTitle?: string
    form?: React.ReactNode;
    isSave?: boolean;
    hintSubmitButton?: boolean
    cancelButtonName?: string;
    exitRightIcons?: () => void;
    enable_up_transition?: boolean;
    maxWidth?: "sm" | "md" | "lg" | "xl"
    scrollBody?: boolean;
    disabledSubmitButton?: boolean;
    enableButtonEdit?: boolean;
    onClickButtonEdit?: () => void;
    icon?: React.ReactNode;
    custom_cancel_button?: React.ReactNode;
}

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="down" ref={ref} {...props} />;
});


export default function ModalCustom(props: ModalProps) {
    const { open,
        handleClose,
        onClick,
        disabledSubmitButton,
        title, subTitle,
        form,
        isSave,
        hintSubmitButton,
        cancelButtonName,
        enable_up_transition,
        scrollBody,
        exitRightIcons,
        maxWidth,
        enableButtonEdit,
        onClickButtonEdit,
        custom_cancel_button
    } = props;
    const { t } = useTranslation();
    const [scroll, _] = React.useState<DialogProps['scroll']>(scrollBody ? 'body' : 'paper');
    const descriptionElementRef = React.useRef<HTMLElement>(null);
    React.useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);
    return (
        <Dialog
            open={open}
            scroll={scroll}
            onClose={handleClose}
            TransitionComponent={enable_up_transition ? Transition : undefined}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="relative"
            maxWidth={maxWidth || "sm"}
            fullWidth
            PaperProps={{
                sx: {
                    boxShadow: "0 0 17px 0 rgba(0,0,0,0.15)",
                    borderRadius: "8px"
                }
            }}
            BackdropProps={{
                sx: {
                    backgroundColor: 'rgba(255, 255, 255, 0.3)',
                    WebkitBackdropFilter: 'blur(5px)',
                    backdropFilter: 'blur(5px)',
                },
                timeout: 500,
            }}
        >
            <DialogContent
                ref={descriptionElementRef}
                className='flex flex-col items-center justify-center' sx={{ gap: '10px' }}>
                {props.icon}
                {exitRightIcons && (
                    <IconButton sx={{ position: "absolute", top: 10, right: 10 }} onClick={() => exitRightIcons()}>
                        <CancelPresentationOutlinedIcon />
                    </IconButton>
                )}
                <Typography sx={{ fontSize: '24px', fontWeight: '600', textAlign: "center", color: '#4A4A4A' }}>
                    {title}
                </Typography>
                {subTitle && <Typography sx={{ fontSize: '18px', fontWeight: '400', color: '#4A4A4A' }}>{subTitle}</Typography>}

                {form && form}

                <Box className='flex justify-center' sx={{ gap: '15px', width: '100%' }}>
                    {custom_cancel_button ? (
                        <>
                            {custom_cancel_button}
                        </>
                    ) : (
                        <ButtonOutlined fullWidth buttonName={cancelButtonName || t("BUTTON.CANCEL")} onClick={handleClose} />
                    )}
                    {!hintSubmitButton &&
                        (
                            <ContainerButton
                                sxContainer={{ width: "auto" }}
                                buttonData={[
                                    {
                                        seq: 1,
                                        key: 'SUBMIT',
                                        type: "SAVE",
                                        label: isSave ? t("BUTTON.SAVE") : t("BUTTON.SUBMIT"),
                                        buttonProps: {
                                            disabled: disabledSubmitButton,
                                            onClick: onClick
                                        }
                                    }
                                ]}
                            />
                        )
                    }
                    {enableButtonEdit && <ButtonContained mode="edit" type={'add'} buttonName="แก้ไข" onClick={onClickButtonEdit} />}
                </Box>
            </DialogContent>
        </Dialog>
    )
}
